import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';

/**
 * Mirrors the visual viewport's height onto `--visual-viewport-height`.
 *
 * `dvh` tracks collapsing browser chrome but not the onscreen keyboard: with the keyboard up,
 * `100dvh` still reports the full screen, so height caps built on it reach behind the keyboard.
 * `visualViewport.height` does shrink, on both iOS Safari and Android Chrome.
 *
 * Falls back to the `100dvh` default declared in `globals.css` where the API is unavailable.
 */
export const useVisualViewportHeight = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
};
function _temp() {
  const viewport = window.visualViewport;
  if (!viewport) {
    return;
  }
  const update = () => {
    document.body.style.setProperty("--visual-viewport-height", `${viewport.height}px`);
  };
  update();
  viewport.addEventListener("resize", update);
  return () => {
    viewport.removeEventListener("resize", update);
    document.body.style.removeProperty("--visual-viewport-height");
  };
}